import { useQuery } from "@tanstack/react-query";
import { ONE_HOUR, REACT_APP_OMS_BASE_URL } from "constants/constants";
import tokenUtils from "utils/tokenUtils";



const fetchOrderDetailsAPI = async (uamId) => {
  const token = tokenUtils.getToken();

  const response = await fetch(
    `${REACT_APP_OMS_BASE_URL}/fetch-customer-orders-details`,
    {
      method: "POST",
      headers: {
        accept: "application/json",
        "accept-language": "en-US,en;q=0.7",
        "cache-control": "no-cache",
        "content-type": "application/json",
        origin: "https://adminsupport.infinitylearn.com",
        pragma: "no-cache",
        priority: "u=1, i",
        referer: "https://adminsupport.infinitylearn.com/",
        "auth-token": token || "",
      },
      body: JSON.stringify({ uam_id: String(uamId) }),
    },
  );

  if (!response.ok) {
    const errorJson = await response.json().catch(() => ({}));
    const errorMsg =
      errorJson?.message ||
      errorJson?.detail ||
      "An unexpected error occurred. Please try again.";
    throw new Error(errorMsg);
  }

  const result = await response.json();

  if (result.status === "success" && result.data?.order_details) {
    return result;
  }

  throw new Error(
    result?.message || "Unable to load order details. Please try again.",
  );
};

export const useFetchOrderDetails = (uamId) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["orderDetails", uamId],
    queryFn: () => fetchOrderDetailsAPI(uamId),
    enabled: !!uamId,
    staleTime: ONE_HOUR,
    refetchOnMount: "always",
    retry: 1,
  });

  return { data, isLoading, error, refetch };
};
